import { inject, provide } from '@vue/composition-api';
import { StoreOptions } from 'vuex';
import { RootState } from '@/store/types';
import Vuex from 'vuex';

const StoreSymbol = Symbol();

export function provideStore(store: any) {
  provide(StoreSymbol, store);
}

export function useStore(): any {
  const store = inject(StoreSymbol);
  if (!store) {
    //  future
  }
  return store;
}
